import { useQuery } from '@tanstack/react-query';

import { listMessages } from '../api/dialogs';

/** Newest-first page from the API, exposed oldest-first for a chronological feed. */
export function useMessages(dialogId: string | undefined) {
  const query = useQuery({
    queryKey: ['dialogs', 'messages', dialogId],
    queryFn: () => listMessages(dialogId as string),
    enabled: Boolean(dialogId),
    refetchOnWindowFocus: false,
  });

  const chronological = [...(query.data?.items ?? [])].reverse();
  return { ...query, messages: chronological };
}
